import { Component, OnInit, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {LoginService} from '../login.service';
import { Router,RouterModule} from '@angular/router';
import * as $ from 'jquery';

@Component({
  selector: 'app-goodcause',
  templateUrl: './goodcause.component.html',
  styleUrls: ['./goodcause.component.css']
})
export class GoodcauseComponent implements OnInit {
  @Input() value:any;
  month:any;
  reasonType:any;
  notes:any;
  noteSize:any=0;
  goodCausereason:any='';
  exemption:any='';
  reasons:any=[];
  outcome:any='';
  status:Boolean = false;

  constructor(public toastService:ToastrService, public loginService:LoginService, public router:Router) { }

  ngOnInit() {
    if(this.value != undefined){
      this.notes = this.value.action.notes;
      this.status = true;
      this.reasonType = this.value.action.reason;
      this.month = this.value.action.month.split('-')[1] + this.value.action.month.split('-')[0];
      this.changeOutcome();
    }
    this.loginService.staticData.get("NonCompReasonDesc").forEach((element)=>{
      this.reasons.push(element);
      this.goodCausereason+= element.name + ', ';
    });
    this.loginService.staticData.get("ExemptionReasonsDesc").forEach((element)=>{
      this.reasons.push(element);
      this.exemption+= element.name + ', ';
    });
    this.goodCausereason = this.goodCausereason.slice(0, -2);
    this.exemption = this.exemption.slice(0, -2);
  }
  onQuickTextChanged(event) {
    if(this.notes != undefined){
      this.noteSize = this.notes.length;
    }
  }
  validate(){
    if(this.month != null || this.month != undefined){
      if( this.month.length < 6 || parseInt(this.month.substring(0, 2)) > 12){
        this.month = undefined;
      }
  }
}
  changeOutcome(){
    if(this.loginService.staticData.get("NonCompReasonDesc").find(obj => obj.value == this.reasonType)){
      this.outcome = 'Good Cause';
    }
    else{
      this.outcome = 'Exemption';
    }
  }
  save(){
    let dt = new Date();
    let requestType;
    if(this.outcome == 'Good Cause'){
      dt.setDate(new Date().getDate() + parseInt(this.loginService.staticData.get("TASKDUEDATES").find(obj => obj.value == 'CG').name));
      requestType = 'CG';
    }
    else{
      dt.setDate(new Date().getDate() + parseInt(this.loginService.staticData.get("TASKDUEDATES").find(obj => obj.value == 'CE').name));
      requestType = 'CE';
    }
    let requestSP = {
      perId:this.loginService.personId,
      notes:this.notes,
      month:this.month.substring(2,7) + '-' + this.month.substring(0, 2) + '-' + '01',
      reason:this.reasonType,
      dueDate:dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate(),
      type:requestType
    }
    
    console.log(" Calling Stored Procedure - savegoodCause");

    this.loginService.savegoodCause(requestSP).subscribe((data)=>{
      if(data['message']=='success'){
        console.log("SP success====");
        let requestWP = {
          perId:this.loginService.personId,
          notes:this.notes,
          month:this.month.substring(2,7) + '-' + this.month.substring(0, 2) + '-' + '01',
          reason:this.reasonType,
          requestType:requestType
        }

        this.loginService.saveNoncompliance(requestWP).subscribe((data)=>{
      
          if(data['message']=='success'){
            console.log("WP success====");
            this.toastService.success('Successfully saved your request','My Requests');
            $("#closeConfirm").click();
            this.router.navigate(['requests']);
          }
          else{
            console.log("WP failure====");
           this.toastService.error('Record not saved: Please review or contact Help Desk','My Requests');
             
           $("#closeConfirm").click();
          }
        },error=>{
          this.toastService.error('Record not saved: Please review or contact Help Desk','My Requests');
          $("#closeConfirm").click();
        })

        $("#closeConfirm").click();
        this.router.navigate(['requests']);
      }
      else{
        console.log("SP failure ====");
        this.toastService.error('Record not saved: Please review or contact Help Desk','My Requests');
        $("#closeConfirm").click();
      }
    },error=>{
      this.toastService.error('Record not saved: Please review or contact Help Desk','My Requests');
      $("#closeConfirm").click();
    })
  
    console.log(" Calling workerportal -saveNoncompliance");



    
  }

}



// WEBPACK FOOTER //
// ./src/app/goodcause/goodcause.component.ts